var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldsWrapper',{staticClass:"wrapper"},[_c('button',{staticClass:"large-expand-btn",attrs:{"disabled":_vm.isDisabled,"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_c('BaseIconText',{attrs:{"icon-url":_vm.icon}},[_vm._t("default")],2)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }